/* eslint-disable import/no-absolute-path */
import right from '/assets/images/right.svg';
import { OFFER, PRICING } from '../constants';

export const rightImg = right;

export const fmt = (n) => n.toLocaleString('en-IN');

let _offerStart = null;
export const offerStart = () => {
  if (_offerStart !== null) return _offerStart;
  try {
    const val = localStorage.getItem(OFFER.storageKey);
    if (val && !isNaN(Number(val))) {
      _offerStart = Number(val);
      return _offerStart;
    }
    _offerStart = Date.now();
    localStorage.setItem(OFFER.storageKey, _offerStart.toString());
    return _offerStart;
  } catch (e) {
    if (_offerStart === null) _offerStart = Date.now();
    return _offerStart;
  }
};

export const nextDeadline = (now = Date.now()) => Math.min(offerStart() + OFFER.windowMs, new Date(OFFER.endsAt).getTime());

export const offerActive = (now = Date.now()) => OFFER.wpFree && now < nextDeadline(now);

export const wpDelta = (now) => offerActive(now) ? 0 : PRICING.platforms.wp.price - PRICING.platforms.static.price;

export const offerDeadlineLabel = () => {
  let s = new Date(nextDeadline()).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata' });
  return s.replace(/ at /gi, ', ').replace(/,+/g, ',').replace(/\s+/g, ' ').replace(/(am|pm)/i, m => m.toLowerCase()).trim() + ' IST';
};

let _quoteNo = null;
export const getQuoteNo = () => {
  if (_quoteNo) return _quoteNo;
  try {
    let q = localStorage.getItem('gd_quote_no');
    if (!q) {
      q = `QT-${Math.floor(100000 + Math.random() * 900000)}`;
      localStorage.setItem('gd_quote_no', q);
    }
    _quoteNo = q;
    return q;
  } catch (e) {
    if (!_quoteNo) {
      _quoteNo = `QT-${Math.floor(100000 + Math.random() * 900000)}`;
    }
    return _quoteNo;
  }
};
